document.documentElement.classList.remove('no-js');

/* ---------- Age gate ---------- */
(function () {
  var gate = document.getElementById('AgeGate');
  if (!gate) return;
  var KEY = 'thca_age_verified';
  try {
    if (localStorage.getItem(KEY) === 'yes') {
      gate.setAttribute('data-hidden', '');
      gate.style.display = 'none';
    }
  } catch (e) {}

  gate.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-age-confirm]');
    if (!btn) return;
    if (btn.getAttribute('data-age-confirm') === 'yes') {
      try { localStorage.setItem(KEY, 'yes'); } catch (e) {}
      gate.style.display = 'none';
    }
  });
})();

/* ---------- Mobile nav ---------- */
(function () {
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (!toggle || !nav) return;
  toggle.addEventListener('click', function () {
    var isOpen = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen);
  });
})();

/* ---------- Product gallery thumbs ---------- */
(function () {
  var thumbs = document.querySelectorAll('[data-thumb]');
  var mainImg = document.getElementById('ProductMainImage');
  if (!thumbs.length || !mainImg) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      mainImg.src = thumb.getAttribute('data-full');
    });
  });
})();

/* ---------- Cart drawer ---------- */
var CartDrawer = (function () {
  var drawer = document.getElementById('CartDrawer');
  var itemsEl = drawer && drawer.querySelector('[data-cart-items]');
  var emptyEl = drawer && drawer.querySelector('[data-cart-empty]');
  var footerEl = drawer && drawer.querySelector('[data-cart-footer]');
  var subtotalEl = drawer && drawer.querySelector('[data-cart-subtotal]');
  var countEls = document.querySelectorAll('[data-cart-count]');

  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function render(cart) {
    if (!drawer) return;
    countEls.forEach(function (el) { el.textContent = cart.item_count; });

    if (cart.item_count === 0) {
      emptyEl.style.display = 'block';
      footerEl.hidden = true;
      itemsEl.innerHTML = '';
      return;
    }

    emptyEl.style.display = 'none';
    footerEl.hidden = false;
    subtotalEl.textContent = moneyFormat(cart.total_price);

    itemsEl.innerHTML = cart.items.map(function (item) {
      return '' +
        '<li class="cart-drawer__item">' +
          (item.image ? '<img src="' + item.image + '" alt="' + item.product_title + '">' : '') +
          '<div class="cart-drawer__item-info">' +
            '<h4>' + item.product_title + '</h4>' +
            '<span class="mono">' + item.quantity + ' &times; ' + moneyFormat(item.price) + '</span>' +
          '</div>' +
        '</li>';
    }).join('');
  }

  function refresh() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(render).catch(function () {});
  }

  function open() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]')) { refresh(); open(); }
    if (e.target.closest('[data-cart-close]')) close();
  });

  refresh();
  return { refresh: refresh, open: open, close: close };
})();

/* ---------- Add to cart (quick add + product form) ---------- */
(function () {
  function addToCart(variantId, qty, btn) {
    if (!variantId) return;
    if (btn) { btn.disabled = true; btn.dataset.originalText = btn.textContent; btn.textContent = 'Adding…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) { btn.textContent = 'Added ✓'; }
        CartDrawer.refresh();
        CartDrawer.open();
      })
      .catch(function () {
        if (btn) btn.textContent = 'Try again';
      })
      .finally(function () {
        if (btn) {
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = btn.dataset.originalText;
          }, 1200);
        }
      });
  }

  document.addEventListener('click', function (e) {
    var quickAdd = e.target.closest('[data-add-to-cart]');
    if (quickAdd) {
      e.preventDefault();
      addToCart(quickAdd.getAttribute('data-variant-id'), 1, quickAdd);
    }
  });

  var productForm = document.querySelector('[data-add-to-cart-form]');
  if (productForm) {
    productForm.closest('form').addEventListener('submit', function (e) {
      e.preventDefault();
      var variantInput = document.getElementById('ProductSelectedVariant');
      var qtyInput = document.getElementById('Quantity');
      addToCart(variantInput ? variantInput.value : null, qtyInput ? parseInt(qtyInput.value, 10) : 1, productForm);
    });
  }
})();
